import React from 'react';
import { Form, Col, Row, InputGroup } from 'react-bootstrap';
import styles from './customDraggbleTextField.module.scss';
import ReactTooltip from 'react-tooltip';

export const CustomDraggbleTextField = (props) => {
    console.log(props.errorMessage)
    return (
        <div>
            <div className={styles.inputMainDiv}>
                
                 <div className={styles.dragIconDiv} >
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="menu-05">
                            <path id="Icon" d="M2 6.16666H14M2 10.8333H14" stroke="#475467" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                    </svg>
                </div>


                <Form.Control
                    className={`
                        ${props.classType === 'defaultTextBox' ? styles.defaultTextBox : ''}
                        ${props.classType === 'disabledTextBox' ? styles.disabledTextBox : ''}
                        ${props.classType === 'savableAndCancelableTextBox' ? styles.savableAndCancelableTextBox : ''}
                    `}
                    placeholder={props.placeholder}
                    onChange={props.handleOnChange}
                    name={props.name}
                    type={props.type}
                    isInvalid={props.isInvalid}
                    value={props.value}
                    disabled={props.disabled}
                    maxLength={props.maxlength}
                    pattern={props.pattern}
                    readOnly={props.readOnly}
                    key={props.keyValue}
                    required={props.required}
                />

                <div className={styles.cancelIconDiv} onClick={props.onCancelClick} key={(props.keyValue) + 1}>
                    <svg className={styles.cancelIcon} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="trash-01">
                            <path id="Icon" d="M13.3333 5.49999V4.83332C13.3333 3.8999 13.3333 3.43319 13.1517 3.07667C12.9919 2.76307 12.7369 2.5081 12.4233 2.34831C12.0668 2.16666 11.6001 2.16666 10.6667 2.16666H9.33333C8.39991 2.16666 7.9332 2.16666 7.57668 2.34831C7.26308 2.5081 7.00811 2.76307 6.84832 3.07667C6.66667 3.43319 6.66667 3.8999 6.66667 4.83332V5.49999M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.49999H17.5M15.8333 5.49999V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5608C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5608C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.49999" stroke="#B42318" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                    </svg>

                </div>

            </div>
            {(props.errorMessage && props.value) && (
                <div className={`${styles.errorDiv} ${styles.errorMsg}`}>
                    {props.errorMessage}
                </div>
            )}
        </div>

    )
}